export enum LocalStorageKey {
  USER = "user",
  PENDING_USER = "pending_user",
  EXPIRES_AT = "expires_at",
  LOCALE = "locale"
}
